import React from 'react'
import {FaMapMarkerAlt} from 'react-icons/fa'
import SectionSkeleton from '@page-components/CheckoutV3/components/SectionSkeleton'

export default function Skeleton() {
  return <SectionSkeleton icon={<FaMapMarkerAlt size={18} />} />
}
